<!--
 * @Author: hongye
 * @Date: 2020-10-28 16:54:24
 * @LastEditTime: 2023-12-25 16:22:52
 * @Description: 
-->
<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
          class="main-r_top_nav active"
      >{{$t('apiDoc.在线文档')}}</span
      >
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom">
      <online-doc :onlineData="onlineData">
        <template #api_addr_info>
          <p class="api_addr_info">{{$t('onlineDoc.地址')}}</p>
          <p class="api_addr_info">{{$t('onlineDoc.请求方法')}}<span>POST</span></p>
          <p class="api_addr_info">{{$t('onlineDoc.数据类型')}}<span>X-WWW-FORM-URLENCODED </span></p>
          <p class="api_addr_info">{{$t('onlineDoc.响应类型')}}<span>JSON</span></p>
        </template>
      </online-doc>
    </div>
    <!-- 在线文档 END -->
  </div>
</template>

<script>
  import onlineDoc from "../components/onlineDoc";
  export default {
    name: "statusFeedback",

    components: {onlineDoc},
    data() {
      return {
        onlineData: {
          //接口描述
          apiDesc: `${this.$t('onlineDoc.trackDescription_3')}`,

          //参数描述  START
          postDataList: [
            //   请求头参数
            {
              title: 'Headers',
              value: [
                {name: "apiAccount", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`,},
                {name: "digest", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.签名字符串')}`,},
                {name: "timestamp", type: "Number", require: "Y", normal: "", describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
              ]
            },
             { 
                title:`${this.$t('onlineDoc.请求参数')}`, 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title: `${this.$t('onlineDoc.业务参数')}`,
              value: [
                {name: "billCode", type: "String(30)", require: "Y", normal: "", describe: `${this.$t('onlineDoc.运单号')}`},
                {name: "txlogisticId", type: "String(60)", require: "N", normal: "", describe: `${this.$t('onlineDoc.客户订单号')}`},
                {name: "details", type: "Array", require: "Y", normal: "", describe: `${this.$t('onlineDoc.快递轨迹详情')}`}
              ]
            },
            {
              title:`${this.$t('onlineDoc.details类型说明')}`,
              value: [
                {name: "scanTime", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.扫描时间')}`},
                {name: "desc", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.轨迹描述')}`},
                {name: "scanType", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.scanType')}`},
                {name: "scanCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.scanCode')}`},
                {name: "problemType",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.problemType')}`},
                {name: "scanNetworkName", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.扫描网点名称')}`},
                {name: "scanNetworkId", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.扫描网点ID')}`},
                {name: "staffName", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.业务员姓名')}`},
                {name: "staffContact", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.业务员联系方式')}`},
                {name: "scanNetworkContact", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.扫描网点联系方式')}`},
                {name: "scanNetworkProvince", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.扫描网点省份')}`},
                {name: "scanNetworkCity", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.扫描网点城市')}`},
                {name: "scanNetworkArea", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.扫描网点区/县')}`},
                {name: "nextStopName", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.上一站(到件)或下一站名称(发件)')}`},
                {name: "staffLng ", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.经度')}`},
                {name: "staffLat", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.纬度')}`},
                {name: "signer", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.签收人')}`},
                {name: "signName", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.签收类型名称')}`},
                {name: "signatureUrl", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.电子签名图片')}`},
                {name: "sigPicUrl", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.签收图片')}`}
              ]
            }
          ],
          //参数描述  END
          //报文描述 start
          responseDataList: [

            //   响应参数
            {
              title: `${this.$t('onlineDoc.响应参数')}`,
              value: [
                {name: "code", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.返回码，见附录')}`},
                {name: "msg", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.描述')}`},
                {name: "data", type: "String", require: "Y", normal: "", describe: `${this.$t('onlineDoc.业务数据')}`},
              ]
            }
          ],
          //请求示例
          requestCode: `Header：
apiAccount=1362
digest=U40e5sumorgd3YgZzU61Mw==
timestamp=1565238848921



Body：
bizContent={
{
	"billCode": "1146708484138602002",
	"details": [{
            "billCode":"UT0000264445622",
            "desc":"【南京雨花台春江新城网点】您的极兔小哥 test1040 已取件。如需联系网点，请拨打 15850664590 特殊时期，您的牵挂，让极兔小哥为您速递！ᕱ ᕱ",
            "scanNetworkArea":"江宁区",
            "scanNetworkCity":"南京市",
            "scanNetworkContact":"15850664590",
            "scanNetworkId":1772,
            "scanNetworkName":"南京雨花台春江新城网点",
            "scanNetworkProvince":"江苏省",
            "scanNetworkTypeName":"南京雨花台春江新城网点",
            "scanTime":"2020-07-16 09:26:15",
            "scanType":"快件揽收"
        },
		{
            "billCode":"UT0000264445622",
            "desc":"亲，有您的快递！【南京玄武网点】的极兔小哥 test1042 (13123456789) 正带着包裹来见您，如需联系该网点，请拨打 17314954950 今天的极兔小哥，体温正常，口罩戴好，消毒到位，即将为您打call",
            "scanNetworkArea":"玄武区",
            "scanNetworkCity":"南京市",
            "scanNetworkContact":"17314954950",
            "scanNetworkId":33,
            "scanNetworkName":"南京玄武网点",
            "scanNetworkProvince":"江苏省",
            "scanNetworkTypeName":"南京玄武网点",
            "scanTime":"2020-07-16 09:26:31",
            "scanType":"出仓扫描"
        }	],
	"txlogisticId": "8792773877787"
}
}`,
          //返回示例
          responseCode: {
            'code': '1',
            'msg': 'success',
            'data':"SUCCESS"
        } ,
        errcodeJson: []
        }
      }
    },
    methods: {
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../css/apiTest.scss";
</style>
